<template>
  <div class="schedule-layout">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'ScheduleLayout',
  beforeDestroy() {
    // Clean up any schedule-specific stylesheets
    document.querySelectorAll('link[data-layout="schedule"]').forEach(link => link.remove());
  }
};
</script>

<style scoped>
.schedule-layout {
  min-height: 100vh;
}
</style>
